@use '@/styles/tokens' as *;

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-5);

  @include up('sm') {
    grid-template-columns: repeat(2, 1fr);
  }

  @include up('lg') {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Mirrors device-card.module.scss `.card` outer dimensions. */
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 272px;
  padding: var(--space-6);
  background: var(--surface-card);
  border: 1px solid var(--border-subtle);
  border-radius: 24px;
  box-shadow: var(--shadow-tab);
  overflow: hidden;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
}

.name {
  margin-top: var(--space-3);
}

/* Mirrors `.media` — centred product image area with the status pill at the bottom. */
.media {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
  margin-top: var(--space-2);
}

.pill {
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
}

/* Mirrors `.action` — the circular power control bottom-right. */
.action {
  position: absolute;
  right: 38px;
  bottom: -20px;
}
